import { useState } from 'react'
import { Plane } from 'lucide-react'
import { getAirlineLogoUrl } from '../lib/utils'

export default function AirlineLogo({ iata, size = 'md', className = '' }) {
  const [failed, setFailed] = useState(false)
  const url = getAirlineLogoUrl(iata)

  const sizes = { sm: 'w-6 h-6', md: 'w-12 h-12', lg: 'w-16 h-16' }
  const iconSizes = { sm: 'w-3.5 h-3.5', md: 'w-6 h-6', lg: 'w-8 h-8' }
  const box = sizes[size] || sizes.md
  const icon = iconSizes[size] || iconSizes.md

  if (!url || failed) {
    return (
      <div className={`${box} rounded-xl bg-flight-cyan/20 flex items-center justify-center shrink-0 ${className}`}>
        <Plane className={`${icon} text-flight-cyan`} />
      </div>
    )
  }

  return (
    <div className={`${box} rounded-xl overflow-hidden flex items-center justify-center shrink-0 ${className}`}>
      <img src={url} alt="" onError={() => setFailed(true)} className="w-full h-full object-cover" />
    </div>
  )
}
